import { render } from "./boton.vue?vue&type=template&id=4f477d2f"
import script from "./boton.vue?vue&type=script&lang=js"
export * from "./boton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__